const tdClassName =
  "py-2 pl-2.5 pr-16 border-t border-black-200 border-r last:border-r-0";
const thClassName =
  "py-2 pl-2.5 pr-16 border-black-200 border-r last:border-r-0";

export default function DNSRecordsTable({
  records,
}: {
  records: { type: string; name: string; value: string }[];
}) {
  return (
    <table className="mt-1.5 w-full text-button-xs border border-separate border-spacing-0 rounded-2xl border-black-200">
      <thead>
        <tr className="text-left text-black-500">
          <th className={thClassName}>Type</th>
          <th className={thClassName}>Name</th>
          <th className={thClassName}>Value</th>
        </tr>
      </thead>
      <tbody>
        {records.map(({ type, name, value }) => (
          <tr key={type} className="group">
            <td className={tdClassName}>{type}</td>
            <td className={tdClassName}>{name}</td>
            <td className={tdClassName}>{value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
